import { render } from "./StandardMssObservationFormT.vue?vue&type=template&id=21da4efa"
import script from "./StandardMssObservationFormT.vue?vue&type=script&lang=js"
export * from "./StandardMssObservationFormT.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__